import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPagination = (state) => get(state, 'custom_fields_employees.list.pagination', {}); // Ubicacion en Stage (Redux)
export const getFilters = (state) => get(state, 'custom_fields_employees.list.filters', {});

export const getCustomFieldsEmployeesIds = (state) =>
  get(state, 'custom_fields_employees.list.result.custom_fields_employees', []);
export const getCustomFieldsEmployees = (state) =>
  get(state, 'custom_fields_employees.list.entities.custom_fields_employees', {});

export const getIsLoading = (state) => get(state, 'custom_fields_employees.list.isLoading', false);
export const getNeedFetch = (state) => get(state, 'custom_fields_employees.list.needFetch', false);

export const getIsFetching = (state) =>
  get(state, 'custom_fields_employees.form.isFetching', false);
export const getIsFetchingConfig = (state) =>
  get(state, 'custom_fields_employees.form.isFetchingConfig', false);
export const getIsSaving = (state) => get(state, 'custom_fields_employees.form.isSaving', false);
export const getEditing = (state) => get(state, 'custom_fields_employees.form.editing', false); // Esto esta vacio es el custom field de empleados. (en reducer recordad cambiar employee por project)

export const getVisibleCustomFieldsEmployees = createSelector(
  [getCustomFieldsEmployeesIds, getCustomFieldsEmployees],
  (ids, employees) => ids.map((id) => employees[id]).filter((project) => !project.deleted) // Se debe cambiar la variable del project por la que entregue en la respuesta el data->project
);



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/selectors/employees_selectors.js